import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useIsMounted from '../../hooks/useIsMounted.jsx';
import './PrivacyPolicy.scss';

function PrivacyPolicy() {
  const [policies, setPolicies] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMountedComponent = useIsMounted();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setLoading(true);
    axios.get('/api/v1/static/privacy')
      .then(({ data }) => {
        if (isMountedComponent) {
          const $data = $(data);
          const content = $data.find('section .container').html()
            || $data.find('.content.container').html()
            || data;
          if (content) {
            setPolicies(content);
          }
        }
      }).finally(() => {
        if (isMountedComponent) {
          setLoading(false);
        }
      });
  }, [i18n.language]);

  return <Container id="PrivacyPolicy">
    {loading ?
      <Card className="empty mt-2">
        {t('common.loading')}...
      </Card> :
      <span dangerouslySetInnerHTML={{ __html: policies }} />
    }
  </Container>;
}

export default PrivacyPolicy;